import { createApp } from "vue";
import App from "./App.vue";
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import router from "./router";
import VueCookies from 'vue-cookies'
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import svgIcon from "./components/SvgIcon/index.vue";
import './assets/svgs/index'

import "./assets/css/index.scss"; // 确保这个在引入 Element Plus 样式之前
import 'element-plus/dist/index.css'
import "element-plus/theme-chalk/dark/css-vars.css";


const pinia = createPinia()
pinia.use(piniaPluginPersistedstate);

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(pinia)
  .use(ElementPlus)
  .use(router)
  .use(VueCookies)
  .component("svg-icon", svgIcon)
  .mount("#app");
